import styled from 'styled-components';

const Wrap = styled.div`
  background-color: white;
  border-top-left-radius: 300px;
`;

export default { Wrap };
